import './Desktop.scss';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Application, Assets, AnimatedSprite } from 'pixi.js';
import { ScratchCard } from 'scratchcard-js'
import bg from './assets/desktop_bg.jpg'
import bull from "./assets/bull.png";
import chicken from "./assets/chicken.png";
import doggy from "./assets/doggy.png";
import dragon from "./assets/dragon.png";
import horse from "./assets/horse.png";
import lamb from "./assets/lamb.png";
import mice from "./assets/mice.png";
import monkey from "./assets/monkey.png";
import piggy from "./assets/piggy.png";
import rabbit from "./assets/rabbit.png";
import snake from "./assets/snake.png";
import tiger from "./assets/tiger.png";
import redCircle from "./assets/redcircle.png";
import redLantern from "./assets/lanternset.png";
import videoframe from "./assets/videoframe.png";
import logoSpin from "./assets/logo_spin.png";
import logo from "./assets/logo.png";
import scratch from "./assets/scratch.png";
import popupvideoframe from "./assets/frame-horizon.png"
import verticalvideoframe from "./assets/frame-vertical.png"
import close from "./assets/close-button.png"
import bull_word from "./assets/words/ox.png";
import chicken_word from "./assets/words/chicken.png";
import doggy_word from "./assets/words/dog.png";
import dragon_word from "./assets/words/dragon.png";
import horse_word from "./assets/words/horse.png";
import lamp_word from "./assets/words/goat.png";
import mice_word from "./assets/words/rat.png";
import monkey_word from "./assets/words/monkey.png";
import piggy_word from "./assets/words/pig.png";
import rabbit_word from "./assets/words/rabbit.png";
import snake_word from "./assets/words/snake.png";
import tiger_word from "./assets/words/tiger.png";
import career_button from "./assets/career_button.png";
import health_button from "./assets/health_button.png";
import wealth_button from "./assets/wealth_button.png";
import v_frame from "./assets/voucher_frame.png";
import complete_survey from "./assets/completesurvey.png";
import extracode from "./assets/extracode.png";
import x_button from "./assets/x.png";
import form_banner from './assets/form-banner.png';
import * as PIXI from 'pixi.js';

function Desktop() {
    const navigate = useNavigate();
    const [bigg, setBigg] = useState(0);
    const [hideBackShadow, setHideBackShadow] = useState(true);
    const [hideZodiacVideo, setHideZodiacVideo] = useState(true);
    const [zodiacIcon, setZodiacIcon] = useState(snake);
    const [zodiacWord, setZodiacWord] = useState(snake_word);
    const [hideCareer, setHideCareer] = useState(true);
    const [careerBtn, setCareerBtn] = useState(career_button);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(()=>{
        document.body.style.display = "block";
        if(window.innerWidth / window.innerHeight < 1){
            navigate("/");
            return;
        }
        let wheelRoot = null;
        let ringRect = null;
        let pendingTitle = null;
        let titleAttached = false;

        const tryAttachPendingTitle = () => {
            if (!pendingTitle || !wheelRoot || !ringRect || titleAttached) return;
            const titleTargetWidth = ringRect.width * 0.85;
            const titleScale = titleTargetWidth / pendingTitle.width;
            pendingTitle.scale.set(titleScale);
            pendingTitle.zIndex = 10;
            pendingTitle.position.set(0, -ringRect.width * 0.12);
            wheelRoot.addChild(pendingTitle);
            titleAttached = true;
        };


        let init = async() => {
            const app = new Application();
            const app2 = new Application();
            await app.init({ backgroundAlpha: 0, autoResize: true, width:window.innerWidth, height:window.innerWidth*0.5625, resolution: 2, autoDensity: true });
            await app2.init({ backgroundAlpha: 0, autoResize: true, width:window.innerWidth, height:window.innerWidth*0.5625, resolution: 2, autoDensity: true });
            document.getElementById("canvas1")?.appendChild(app.canvas);
            document.getElementById("canvas2")?.appendChild(app2.canvas);

            await Assets.load([
                '/redCircle-0.json',
                '/fortuneCat-0.json',
                '/words-0.json',
                '/horsetitle-1.json',
                '/bestWealth.json',
                '/bestHealth.json',
                '/bestCareer-0.json',
                '/btmRightHorse-0.json',
                '/btmRight-0.json',
                '/horseRunning-0.json',
                '/click_start-0.json',
                '/snack_start.json',
                '/snack_top.json',
                '/wealth_start-0.json',
                '/health_start-0.json',
                '/luck_start-0.json',
                '/greeting-0.json',
                '/reel-0.json',
                '/click_loop-0.json',
                '/snack_loop.json',
                '/wealth_loop-0.json',
                '/health_loop-0.json',
                '/bottom-0.json',
                '/backtohuat_loop-0.json',
                '/luck_loop-0.json',
                '/backword_loop-0.json',
                '/bottom_elem-0.json',
                '/reel_light-0.json',
                '/wishes-0.json',
                '/bottom_right-0.json',
                '/bottom_fan-0.json',
                '/bottom_cloud-0.json',
                '/bottom_left-0.json'
            ]).then(()=>{
                document.body.style.display = "block";
            });

            setTimeout(async () => {
                // ================================
                // 🟡 HORSE TITLE — MULTI-ATLAS SAFE
                // ================================
                await Promise.allSettled(
                    [1, 2, 3, 4, 5].map((i) => Assets.load(`/horsetitle-${i}.json`))
                );

                const titleFrames = [];

                // adjust count if you have more sheets
                for (let i = 1; i <= 5; i++) {
                const key = `/horsetitle-${i}.json`;
                const sheet = PIXI.Assets.get(key);

                if (!sheet || !sheet.data?.frames) continue;

                const frames = Object.keys(sheet.data.frames);
                titleFrames.push(...frames);
                }

                // sort numerically: TITLE1.png, TITLE2.png, ...
                titleFrames.sort((a, b) => {
                    const na = parseInt(a.match(/\d+/)?.[0] ?? 0, 10);
                    const nb = parseInt(b.match(/\d+/)?.[0] ?? 0, 10);
                    return na - nb;
                });

                // 🚨 hard safety check
                if (titleFrames.length === 0) {
                console.error('No TITLE frames found');
                return;
                }

                const titleIntro = new PIXI.AnimatedSprite(
                titleFrames.map(f => PIXI.Texture.from(f))
                );

                // center anchor
                titleIntro.anchor.set(0.5);


                // animation config
                titleIntro.animationSpeed = 0.5;
                titleIntro.loop = false;
                titleIntro.play();


                pendingTitle = titleIntro;
                tryAttachPendingTitle();


                const click_start_anim = Assets.cache.get('/click_start-0.json').data.animations;
                const click_start = AnimatedSprite.fromFrames(click_start_anim["Click to Watch"]);
                click_start.setSize(window.innerWidth * 0.22, window.innerWidth * 0.04);
                click_start.animationSpeed = 1 / 2;
                click_start.position.set(window.innerWidth*0.215, window.innerWidth*0.290);
                click_start.loop = false;
                app.stage.addChild(click_start);
                click_start.onComplete = () =>{
                    app.stage.removeChild(click_start);
                    const click_loop_anim = Assets.cache.get('/click_loop-0.json').data.animations;
                    const click_loop = AnimatedSprite.fromFrames(click_loop_anim["Click to Watch"]);
                    click_loop.animationSpeed = 1 / 2;
                    click_loop.setSize(window.innerWidth * 0.22, window.innerWidth * 0.04);
                    click_loop.position.set(window.innerWidth*0.215, window.innerWidth*0.290);
                    click_loop.loop = true;
                    click_loop.play();
                    click_loop.onLoop = () =>{
                        click_loop.stop();
                        setTimeout(()=>{
                            click_loop.play();
                        }, 2000);
                    }
                    app.stage.addChild(click_loop);
                }

                click_start.play();
            }, 1000);


            //top left snake body
            // const snack_top_anim = Assets.cache.get('/snack_top.json').data.animations;
            // const snack_top = AnimatedSprite.fromFrames(snack_top_anim["Snake Body"]);
            // snack_top.animationSpeed = 1 / 2;
            // snack_top.setSize(window.innerWidth * 0.127, window.innerWidth * 0.1);
            // snack_top.position.set(0, 0);
            // snack_top.loop = false;
            // snack_top.play();
            // app.stage.addChild(snack_top);


            // ================================
            // 🐱 FORTUNE CAT — REPLACES VIDEO BOX
            // ================================

            const videoBoxEl = document.querySelector('.video-box');
            if (!videoBoxEl) {
            console.error('video-box not found');
            } else {
            // ✅ CLICK ON VIDEO BOX (DOM, guaranteed to work)
            videoBoxEl.style.cursor = 'pointer';
            videoBoxEl.addEventListener('click', () => {
            window.open('https://www.hiso33sg4.com/en-sg/mini-game', '_blank');
            });
            const fortuneSheet = PIXI.Assets.get('/fortuneCat-0.json');

            if (!fortuneSheet?.textures) {
                console.error('fortuneCat textures missing');
            } else {
                const boxRect = videoBoxEl.getBoundingClientRect();
                const canvasRect = app.canvas.getBoundingClientRect(); // ⚠️ app, NOT app2

                const frames = Object.keys(fortuneSheet.textures)
                .sort((a, b) => {
                    const na = parseInt(a.match(/\d+/)?.[0] ?? 0, 10);
                    const nb = parseInt(b.match(/\d+/)?.[0] ?? 0, 10);
                    return na - nb;
                });

                // enable stage interaction (do this once)
                app.stage.eventMode = 'static';
                app.stage.hitArea = app.screen

                const fortuneCat = new PIXI.AnimatedSprite(
                frames.map(f => fortuneSheet.textures[f])
                );

                fortuneCat.anchor.set(0.5);
                fortuneCat.animationSpeed = 120 / (30 * 60); // 0.1
                fortuneCat.loop = true;
                fortuneCat.play();
                // make clickable
                fortuneCat.eventMode = 'static';
                fortuneCat.cursor = 'pointer';



                // exact size of video box
                fortuneCat.setSize(
                boxRect.width * 1.25,   // ⬅️ make wider
                boxRect.height * 1.25   // ⬅️ make taller
                );


                // ⚠️ IMPORTANT: explicit hit area
                fortuneCat.hitArea = new PIXI.Rectangle(
                -fortuneCat.width / 2,
                -fortuneCat.height / 2,
                fortuneCat.width,
                fortuneCat.height
                );

                // debug (optional)
                fortuneCat.on('pointerover', () => {
                console.log('fortune cat hover');
                });

                // click
                fortuneCat.on('pointertap', () => {
                window.open('https://www.google.com', '_blank');
                });
                // exact position
                const Y_OFFSET = boxRect.height * 0.18; // tweak 0.15–0.25 if needed

                fortuneCat.position.set(
                boxRect.left - canvasRect.left + boxRect.width / 2,
                boxRect.top - canvasRect.top + boxRect.height / 2 - Y_OFFSET
                );

                app.stage.addChild(fortuneCat); // ✅ THIS IS THE FIX
            }
            }







            const bottom_cloud_anim = Assets.cache.get('/bottom_cloud-0.json').data.animations;
            const bottom_cloud = AnimatedSprite.fromFrames(bottom_cloud_anim["Bottom Cloud_Only"]);
            bottom_cloud.animationSpeed = 1 / 6;
            bottom_cloud.setSize(window.innerWidth * 0.5, window.innerWidth * 0.072);
            bottom_cloud.position.set(window.innerWidth * 0.24, window.innerWidth*0.50);
            bottom_cloud.loop = true;
            bottom_cloud.play();
            app2.stage.addChild(bottom_cloud);

            const bottom_fan_anim = Assets.cache.get('/bottom_fan-0.json').data.animations;
            const bottom_fan = AnimatedSprite.fromFrames(bottom_fan_anim["Chinese fan"]);
            bottom_fan.animationSpeed = 1 / 6;
            bottom_fan.setSize(window.innerWidth, window.innerWidth * 0.366);
            bottom_fan.position.set(0, window.innerWidth*0.2);
            bottom_fan.loop = true;
            bottom_fan.play();
            app2.stage.addChild(bottom_fan);

            setTimeout(() => {
                const startFrames = [];
                const loopFrames = [];

                for (let i = 0; i <= 119; i++) {
                    const frame = `BEST_WEALTH${String(i).padStart(3, "0")}.png`;

                    if (i <= 58) {
                    startFrames.push(frame);   // 000 - 058
                    } else {
                    loopFrames.push(frame);    // 059 - 119
                    }
                }

                // START animation
                const wealth_start = new PIXI.AnimatedSprite(
                    startFrames.map(f => PIXI.Texture.from(f))
                );

                wealth_start.animationSpeed = 0.5;
                wealth_start.loop = false;
                wealth_start.setSize(
                    window.innerWidth * 0.150,
                    window.innerWidth * 0.09
                );
                wealth_start.position.set(
                    window.innerWidth * 0.1,
                    window.innerWidth * 0.0
                );

                wealth_start.play();
                app.stage.addChild(wealth_start);

                // When START finishes → LOOP forever
                wealth_start.onComplete = () => {
                    app.stage.removeChild(wealth_start);
                    wealth_start.destroy();

                    const wealth_loop = new PIXI.AnimatedSprite(
                    loopFrames.map(f => PIXI.Texture.from(f))
                    );

                    wealth_loop.animationSpeed = 0.5;
                    wealth_loop.loop = true;
                    wealth_loop.setSize(
                    window.innerWidth * 0.150,
                    window.innerWidth * 0.09
                    );
                    wealth_loop.position.set(
                    window.innerWidth * 0.1,
                    window.innerWidth * 0.0
                    );

                    wealth_loop.play();
                    app.stage.addChild(wealth_loop);
                };

                // HEALTH animation (from bestHealth.json)

                const healthStartFrames = [];
                const healthLoopFrames = [];

                for (let i = 0; i <= 119; i++) {
                const frame = `BEST_HEALTH${String(i).padStart(3, "0")}.png`;

                if (i <= 58) {
                    healthStartFrames.push(frame);   // 000 - 058
                } else {
                    healthLoopFrames.push(frame);    // 059 - 119
                }
                }

                // START animation
                const health_start = new PIXI.AnimatedSprite(
                healthStartFrames.map(f => PIXI.Texture.from(f))
                );

                health_start.animationSpeed = 0.5;
                health_start.loop = false;
                health_start.setSize(
                window.innerWidth * 0.150,
                window.innerWidth * 0.09
                );
                health_start.position.set(
                window.innerWidth * 0.25,
                window.innerWidth * 0.0
                );

                health_start.play();
                app.stage.addChild(health_start);

                // When START finishes → LOOP forever
                health_start.onComplete = () => {
                app.stage.removeChild(health_start);
                health_start.destroy();

                const health_loop = new PIXI.AnimatedSprite(
                    healthLoopFrames.map(f => PIXI.Texture.from(f))
                );

                health_loop.animationSpeed = 0.5;
                health_loop.loop = true;
                health_loop.setSize(
                    window.innerWidth * 0.150,
                    window.innerWidth * 0.09
                );
                health_loop.position.set(
                    window.innerWidth * 0.25,
                    window.innerWidth * 0.0
                );

                health_loop.play();
                app.stage.addChild(health_loop);
                };

                // CAREER (Luck) animation from bestCareer.json

                const careerStartFrames = [];
                const careerLoopFrames = [];

                for (let i = 0; i <= 119; i++) {
                const frame = `BEST_CAREER${String(i).padStart(3, "0")}.png`;

                if (i <= 58) {
                    careerStartFrames.push(frame);   // 000 - 058
                } else {
                    careerLoopFrames.push(frame);    // 059 - 119
                }
                }

                // START animation
                const career_start = new PIXI.AnimatedSprite(
                careerStartFrames.map(f => PIXI.Texture.from(f))
                );

                career_start.animationSpeed = 0.5;
                career_start.loop = false;
                career_start.setSize(
                window.innerWidth * 0.150,
                window.innerWidth * 0.09
                );
                career_start.position.set(
                window.innerWidth * 0.4,
                window.innerWidth * 0.0
                );

                career_start.play();
                app.stage.addChild(career_start);

                // When START finishes → LOOP forever
                career_start.onComplete = () => {
                app.stage.removeChild(career_start);
                career_start.destroy();

                const career_loop = new PIXI.AnimatedSprite(
                    careerLoopFrames.map(f => PIXI.Texture.from(f))
                );

                career_loop.animationSpeed = 0.5;
                career_loop.loop = true;
                career_loop.setSize(
                    window.innerWidth * 0.150,
                    window.innerWidth * 0.09
                );
                career_loop.position.set(
                    window.innerWidth * 0.4,
                    window.innerWidth * 0.0
                );

                career_loop.play();
                app.stage.addChild(career_loop);
                };


                const reel_anim = Assets.cache.get('/reel-0.json').data.animations;
                const reel = AnimatedSprite.fromFrames(reel_anim["Scroll Animation"]);
                reel.animationSpeed = 1 / 2;
                reel.setSize(window.innerWidth * 0.28, window.innerWidth * 0.104);
                reel.position.set(window.innerWidth*0.636, window.innerWidth*0.232);
                reel.loop = false;
                reel.play();
                app.stage.addChild(reel);
                reel.onComplete = () =>{
                    const reel_light_anim = Assets.cache.get('/reel_light-0.json').data.animations;
                    const reel_light = AnimatedSprite.fromFrames(reel_light_anim["Scroll Light Flare"]);
                    reel_light.animationSpeed = 1 / 2;
                    reel_light.setSize(window.innerWidth * 0.28, window.innerWidth * 0.104);
                    reel_light.position.set(window.innerWidth*0.636, window.innerWidth*0.232);
                    reel_light.loop = false;
                    reel_light.play();
                    app.stage.addChild(reel_light);
                }

                const backtohuat_loop_anim = Assets.cache.get('/backtohuat_loop-0.json').data.animations;
                const backtohuat_loop = AnimatedSprite.fromFrames(backtohuat_loop_anim["Back-to-Huat_Holder"]);
                backtohuat_loop.animationSpeed = 1 / 2;
                backtohuat_loop.setSize(window.innerWidth * 0.24, window.innerWidth * 0.043);
                backtohuat_loop.position.set(window.innerWidth * 0.655, window.innerWidth*0.318);
                backtohuat_loop.loop = true;
                app.stage.addChild(backtohuat_loop);
                setTimeout(()=>{
                    backtohuat_loop.play();
                }, 2000);
                backtohuat_loop.onLoop = () =>{
                    backtohuat_loop.stop();
                    setTimeout(()=>{
                        backtohuat_loop.play();
                    }, 2000);
                }

                const backword_loop_anim = Assets.cache.get('/backword_loop-0.json').data.animations;
                const backword_loop = AnimatedSprite.fromFrames(backword_loop_anim["Back-to-Huat_Wordings"]);
                backword_loop.animationSpeed = 1 / 2;
                backword_loop.setSize(window.innerWidth * 0.22, window.innerWidth * 0.04);
                backword_loop.position.set(window.innerWidth * 0.664, window.innerWidth*0.320);
                backword_loop.loop = true;
                backword_loop.play();
                backword_loop.onLoop = () =>{
                    backword_loop.stop();
                    setTimeout(()=>{
                        backword_loop.play();
                    }, 5000);
                }
                app.stage.addChild(backword_loop);

                // ================================
                // 🎁 CNY WISHES R1 (TexturePacker)
                // ================================

                const wishStartFrames = [];
                const wishLoopFrames = [];

                // IMPORTANT: frame name MUST match JSON exactly
                // "CNY WISHES(R1)000.png" → "CNY WISHES(R1)119.png"

                for (let i = 0; i <= 119; i++) {
                const frame =
                    `CNY WISHES(R1)${String(i).padStart(3, '0')}.png`;

                if (i < 50) {
                    wishStartFrames.push(frame);   // 000–049
                } else {
                    wishLoopFrames.push(frame);    // 050–119
                }
                }

                // ▶️ START animation
                const wish_start = new PIXI.AnimatedSprite(
                wishStartFrames.map(f => PIXI.Texture.from(f))
                );

                wish_start.animationSpeed = 1 / 2;
                wish_start.loop = false;
                wish_start.setSize(
                window.innerWidth * 0.37,
                window.innerWidth * 0.293
                );
                wish_start.position.set(
                window.innerWidth * 0.59,
                window.innerWidth * 0.212
                );

                wish_start.play();
                app.stage.addChild(wish_start);

                // 🔁 When START completes → LOOP forever
                wish_start.onComplete = () => {
                app.stage.removeChild(wish_start);
                wish_start.destroy();

                const wish_loop = new PIXI.AnimatedSprite(
                    wishLoopFrames.map(f => PIXI.Texture.from(f))
                );

                wish_loop.animationSpeed = 1 / 2;
                wish_loop.loop = true;
                wish_loop.setSize(
                    window.innerWidth * 0.37,
                    window.innerWidth * 0.293
                );
                wish_loop.position.set(
                    window.innerWidth * 0.59,
                    window.innerWidth * 0.212
                );

                wish_loop.play();
                app.stage.addChild(wish_loop);
                };




//btm right horse
                const bottomRightFrames = [];

                for (let i = 0; i <= 222; i++) {
                bottomRightFrames.push(
                    `HORSE${String(i).padStart(3, "0")}.png`
                );
                }

                const horse = new PIXI.AnimatedSprite(
                bottomRightFrames.map(f => PIXI.Texture.from(f))
                );

                // animation
                horse.animationSpeed = 0.5;
                horse.loop = true;
                horse.play();

                // anchor feet to ground
                horse.anchor.set(0.5, 1);

                // ✅ SCALE BASED ON DESIGN WIDTH (NOT setSize)
                const DESIGN_HORSE_WIDTH = 280; // tweak this to match Figma/PSD
                const scale = DESIGN_HORSE_WIDTH / horse.width;
                horse.scale.set(scale);

                // position bottom-right
                horse.position.set(
                app.screen.width - horse.width * 0.5, // ✅ flush right
                app.screen.height                      // ground
                );

                // texture filtering (prevents shimmer)
                horse.textures.forEach(t => {
                t.baseTexture.scaleMode = PIXI.SCALE_MODES.LINEAR;
                });

                app.stage.addChild(horse);







// const bottomRightFrames = [];

// // frames 000 → 222
// for (let i = 0; i <= 222; i++) {
//   bottomRightFrames.push(
//     `HORSE${String(i).padStart(3, "0")}.png`
//   );
// }

// const bottom_right = new PIXI.AnimatedSprite(
//   bottomRightFrames.map(f => PIXI.Texture.from(f))
// );

// bottom_right.animationSpeed = 0.5;
// bottom_right.loop = true;

// // 🧠 IMPORTANT: anchor first
// bottom_right.anchor.set(1, 1); // bottom-right corner

// // 🎯 SCALE instead of setSize
// const targetWidth = window.innerWidth * 0.22; // ⬅️ increase this (0.18–0.25)
// const scale = targetWidth / bottom_right.width;
// bottom_right.scale.set(scale);

// // 📍 Position stays correct
// bottom_right.position.set(
//   window.innerWidth,
//   window.innerWidth * 0.37
// );

// bottom_right.play();
// app.stage.addChild(bottom_right);















                // Bottom right drum animation (btmRight-0.json, loop all frames)

                const bottomRightDrumFrames = [];

                for (let i = 0; i <= 119; i++) {
                bottomRightDrumFrames.push(
                    `BTM_RIGHT${String(i).padStart(3, "0")}.png`
                );
                }

                const bottom_rightD = new PIXI.AnimatedSprite(
                bottomRightDrumFrames.map(f => PIXI.Texture.from(f))
                );

                bottom_rightD.animationSpeed = 0.5;
                bottom_rightD.loop = true;
                bottom_rightD.setSize(
                window.innerWidth * 0.2,
                window.innerWidth * 0.131
                );
                bottom_rightD.position.set(
                window.innerWidth * 0.8,
                window.innerWidth * 0.431
                );

                bottom_rightD.play();
                app.stage.addChild(bottom_rightD);


                // ================================
                // 🐎 HORSE RUNNING — multi-atlas, LEFT → RIGHT (15s loop, smooth)
                // ================================

                // 1️⃣ Collect all frames
                const horseRunningFrames = [];

                for (let i = 0; i < 50; i++) {
                const key = `/horseRunning-${i}.json`;
                const sheet = PIXI.Assets.get(key);

                if (!sheet || !sheet.data?.frames) continue;

                const frames = Object.keys(sheet.data.frames);

                // sort numerically: HORSE000.png → HORSE359.png
                frames.sort((a, b) => {
                    const na = parseInt(a.match(/\d+/)?.[0] ?? 0, 10);
                    const nb = parseInt(b.match(/\d+/)?.[0] ?? 0, 10);
                    return na - nb;
                });

                horseRunningFrames.push(...frames);
                }

                // 2️⃣ Safety check
                if (horseRunningFrames.length === 0) {
                console.error("Horse running frames not found");
                } else {

                // 3️⃣ Create sprite
                const horse_running = new PIXI.AnimatedSprite(
                    horseRunningFrames.map(f => PIXI.Texture.from(f))
                );

                // 4️⃣ Animation timing
                // 360 frames / 15 seconds = 24 fps → 24 / 60 = 0.4
                horse_running.animationSpeed = 0.4;
                horse_running.loop = false;

                // 5️⃣ Anchor (feet stay on ground)
                horse_running.anchor.set(0.5, 1);

                // 6️⃣ Scale ONCE (important for smoothness)
                const targetWidth = window.innerWidth * 0.35;
                const scale = targetWidth / horse_running.width;
                horse_running.scale.set(scale);

                // 7️⃣ Texture filtering (prevents shimmer)
                horse_running.textures.forEach(t => {
                    t.baseTexture.scaleMode = PIXI.SCALE_MODES.LINEAR;
                });

                // 8️⃣ Positioning values
                const groundY = window.innerWidth * 0.5625;

                const startX = -horse_running.width;
                const endX = window.innerWidth + horse_running.width;

                horse_running.position.set(startX, groundY);

                // 9️⃣ Movement speed (15 seconds)
                const distance = endX - startX;
                const DURATION = 15; // seconds
                const speedPerFrame = distance / (DURATION * 60);

                // 🔁 Move left → right
                app2.ticker.add(() => {
                    horse_running.x += speedPerFrame;

                    // reset after fully off screen
                    if (horse_running.x > endX) {
                    horse_running.x = startX;
                    }
                });

                // 🔟 Stabilize ticker
                app2.ticker.maxFPS = 60;
                app2.ticker.minFPS = 60;

                // ▶️ Play
                horse_running.play();
                app2.stage.addChild(horse_running);
                }










                const bottom_left_anim = Assets.cache.get('/bottom_left-0.json').data.animations;
                const bottom_left = AnimatedSprite.fromFrames(bottom_left_anim["Bottom Left"]);
                bottom_left.animationSpeed = 1 / 2;
                bottom_left.setSize(window.innerWidth * 0.3, window.innerWidth * 0.374);
                bottom_left.position.set(0, window.innerWidth*0.19);
                bottom_left.loop = true;
                bottom_left.play();

                app.stage.addChild(bottom_left);

            }, 250);

            var items = document.querySelectorAll(".zodiac-container");
            let angle = 360 / 12;
            let radian = angle * Math.PI / 180;
            items.forEach((zodiac, index) => {
                setTimeout(()=>{
                    zodiac.style.left = (Math.sin(-radian*index) * 48 + 50).toFixed(0) + "%";
                    zodiac.style.top = (Math.cos(-radian*index) * 48 + 50).toFixed(0) + "%";
                    zodiac.style.opacity = 1;
                }, index * 75);
            })


            // ================================
            // 🔴 RED CIRCLE (ANCHOR TO ZODIAC RING)
            // ================================

            // 1️⃣ Get zodiac ring DOM center
            const zodiacsEl = document.querySelector('.zodiacs');
            const rect = zodiacsEl.getBoundingClientRect();
            ringRect = rect;
            const canvasRect = app.canvas.getBoundingClientRect();
            const ringCenterX =
            rect.left - canvasRect.left + rect.width / 2;

            const ringCenterY =
            rect.top - canvasRect.top + rect.height / 2;

            // 2️⃣ Create Pixi root container at ring center
            wheelRoot = new PIXI.Container();
            wheelRoot.position.set(ringCenterX, ringCenterY);
            wheelRoot.sortableChildren = true;
            app.stage.addChild(wheelRoot);

        
            // 3️⃣ Build red circle animation frames
            const redCircleFrames = [];

            for (let i = 0; i <= 119; i++) {
            redCircleFrames.push(
                `CIRCLE${String(i).padStart(3, "0")}.png`
            );
            }

            const redCircleAnim = new PIXI.AnimatedSprite(
            redCircleFrames.map(f => PIXI.Texture.from(f))
            );

            // 4️⃣ Configure red circle
            redCircleAnim.anchor.set(0.5);

            // size slightly INSIDE zodiac ring
            redCircleAnim.setSize(
            rect.width * 1.4,
            rect.width * 1.4
            );


            // smooth glow loop (~10s per cycle)
            redCircleAnim.animationSpeed = 120 / (10 * 60);
            redCircleAnim.loop = true;
            redCircleAnim.play();

            // add to wheel root
            redCircleAnim.zIndex = 1;
            wheelRoot.addChild(redCircleAnim);
            tryAttachPendingTitle();









            items.forEach(el => el.firstChild.addEventListener('click', event => {
                showZodiacVideo(event.target.getAttribute("data-name"));
            }));

            document.getElementById("close-zodiac").addEventListener('click', event => {
                hideZodiacVideo();
            });

            document.getElementById("button3").addEventListener('click', event => {
                showCareer();
            });

            document.getElementById("close-career").addEventListener('click', event => {
                closeCareer();
            });

        }
        init().then(()=>{
            initScratch();
        });

        function initScratch(){
            let randNum = Math.floor(Math.random() * (9999 - 0 + 1) + 0);
            const sc = new ScratchCard('#scratch-numbers', {
                scratchType: 3,
                containerWidth: document.getElementById("scratch-img")?.offsetWidth || 0,
                containerHeight: document.getElementById("scratch-img")?.offsetHeight || 0,
                imageForwardSrc: '/scratch.png',
                imageBackgroundSrc: '',
                htmlBackground: '<div class="numbers">' + pad(randNum, 4) + '</div>',
                clearZoneRadius: 20,
                nPoints: 30,
                pointSize: 4,
                percentToFinish: 70,
                callback: function () {
                },
                brushSrc: "",
                enabledPercentUpdate: true
            })

            window.addEventListener('resize', resizeSC);
            function resizeSC() {
                sc.containerWidth = document.getElementById("scratch-img")?.offsetWidth || 0;
                sc.containerHeight = document.getElementById("scratch-img")?.offsetHeight || 0;
            }

            function pad(num , size) {
                num = num.toString();
                while (num.length < size) num = "0" + num;
                return num;
            }

            sc.init();
        }

        randomBig();

        function randomBig(){
            setTimeout(() => {
                let next = Math.floor(Math.random() * (12 - 1 + 1) + 1);
                while(next === bigg){
                    next = Math.floor(Math.random() * (12 - 1 + 1) + 1);
                }
                setBigg(next);
                setTimeout(() => {
                    setBigg(0);
                }, 250);
                randomBig();
            }, Math.floor(Math.random() * (3000 - 250 + 1) + 250));
        }

        function showZodiacVideo(zodiac){
            switch(zodiac){
                case "bull"   : setZodiacIcon(bull); setZodiacWord(bull_word); break;
                case "chicken": setZodiacIcon(chicken); setZodiacWord(chicken_word); break;
                case "doggy"  : setZodiacIcon(doggy); setZodiacWord(doggy_word); break;
                case "dragon" : setZodiacIcon(dragon); setZodiacWord(dragon_word); break;
                case "horse"  : setZodiacIcon(horse); setZodiacWord(horse_word); break;
                case "lamb"   : setZodiacIcon(lamb); setZodiacWord(lamp_word); break;
                case "mice"   : setZodiacIcon(mice); setZodiacWord(mice_word); break;
                case "monkey" : setZodiacIcon(monkey); setZodiacWord(monkey_word); break;
                case "piggy"  : setZodiacIcon(piggy); setZodiacWord(piggy_word); break;
                case "rabbit" : setZodiacIcon(rabbit); setZodiacWord(rabbit_word); break;
                case "snake"  : setZodiacIcon(snake); setZodiacWord(snake_word); break;
                case "tiger"  : setZodiacIcon(tiger); setZodiacWord(tiger_word); break;
            }
            var video = document.getElementById("zodiac-v");
            var source = document.createElement('source');

            source.setAttribute('src', zodiac + '.mp4');
            source.setAttribute('type', 'video/mp4');

            video.appendChild(source);
            video.load();

            setHideBackShadow(false);
            setHideZodiacVideo(false);

            video.play();
        }
        function hideZodiacVideo(){
            setHideBackShadow(true);
            setHideZodiacVideo(true);

            var video = document.getElementById("zodiac-v");
            var isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
            if(isVideoPlaying){
                video.pause();
            }
            video.innerHTML = '';
        }
    }, [])

    function showHealth(){
        setCareerBtn(health_button);
        var video = document.getElementById("career-v");
        var source = document.createElement('source');
        source.setAttribute('src', 'health.mp4');
        source.setAttribute('type', 'video/mp4');
        video.appendChild(source);
        video.load();
        setHideBackShadow(false);
        setHideCareer(false);
    }
    function showWealth(){
        setCareerBtn(wealth_button);
        var video = document.getElementById("career-v");
        var source = document.createElement('source');
        source.setAttribute('src', 'wealth.mp4');
        source.setAttribute('type', 'video/mp4');
        video.appendChild(source);
        video.load();
        setHideBackShadow(false);
        setHideCareer(false);
    }
    function showCareer(){
        setCareerBtn(career_button);
        var video = document.getElementById("career-v");
        var source = document.createElement('source');
        source.setAttribute('src', 'career.mp4');
        source.setAttribute('type', 'video/mp4');
        video.appendChild(source);
        video.load();
        setHideBackShadow(false);
        setHideCareer(false);
    }
    function closeCareer(){
        setHideBackShadow(true);
        setHideCareer(true);
        var video = document.getElementById("career-v");
        var isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
        if(isVideoPlaying){
            video.pause();
        }
        video.innerHTML = '';
    }




    return(
        <div className="desktop">
            <div className={'back-shadow ' + (hideBackShadow ? 'hide' : '')}></div>
            <div className={'zodiac-video ' + (hideZodiacVideo ? 'hide' : '')}>
                <img id="close-zodiac" className='close' src={close} alt={""} loading={"eager"} />
                <div className='word-container'>
                    <img src={zodiacIcon} className={"icon"} alt={""} loading={"eager"} />
                    <img src={zodiacWord} className={"word"} alt={""} loading={"eager"} />
                </div>
                <img className='videoframe' src={popupvideoframe} alt={""} loading={"eager"} />
                <video id="zodiac-v" controls playsInline autoPlay>
                    <source src="null"></source>
                </video>
            </div>
            <div className={'career-video ' + (hideCareer ? 'hide' : '')}>
                <img className='top-button' src={careerBtn} alt={""} loading={"eager"} />
                <img id="close-career" className='close' src={close} alt={""} loading={"eager"} />
                <img className='videoframe' src={verticalvideoframe} alt={""} loading={"eager"} />
                <video id="career-v" controls playsInline autoPlay>
                    <source src="null"></source>
                </video>
            </div>

            <img src={bg} className="bg" alt={""} loading={"eager"} />
            <div id="canvas2"></div>
            <div className='container'>
                <div className="left-side">
                    <div className='button-group'>
                        <div id="button1" onClick={showWealth} className='button1'></div>
                        <div id="button2" onClick={showHealth} className='button2'></div>
                        <div id="button3" onClick={showCareer} className='button3'></div>
                    </div>
                    <div className="wheel">
                        <div className="logo-container">
                            <img src={logo} className="logo" alt={""} loading={"eager"} />
                            <img src={logoSpin} className="logo-spin" alt={""} loading={"eager"} />
                        </div>
                        <div className="zodiacs">
                            <div className="zodiac-container" data-name="bull"   ><img src={bull}    data-name="bull"    className={ (bigg === 1 ? "showBig" : "") + " zodiac bull"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="chicken"><img src={chicken} data-name="chicken" className={ (bigg === 2 ? "showBig" : "") + " zodiac chicken"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="doggy"  ><img src={doggy}   data-name="doggy"   className={ (bigg === 3 ? "showBig" : "") + " zodiac doggy"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="dragon" ><img src={dragon}  data-name="dragon"  className={ (bigg === 4 ? "showBig" : "") + " zodiac dragon"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="horse"  ><img src={horse}   data-name="horse"   className={ (bigg === 5 ? "showBig" : "") + " zodiac horse"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="lamb"   ><img src={lamb}    data-name="lamb"    className={ (bigg === 6 ? "showBig" : "") + " zodiac lamb"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="mice"   ><img src={mice}    data-name="mice"    className={ (bigg === 7 ? "showBig" : "") + " zodiac mice"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="monkey" ><img src={monkey}  data-name="monkey"  className={ (bigg === 8 ? "showBig" : "") + " zodiac monkey"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="piggy"  ><img src={piggy}   data-name="piggy"   className={ (bigg === 9 ? "showBig" : "") + " zodiac piggy"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="rabbit" ><img src={rabbit}  data-name="rabbit"  className={ (bigg === 10 ? "showBig" : "") + " zodiac rabbit"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="snake"  ><img src={snake}   data-name="snake"   className={ (bigg === 11 ? "showBig" : "") + " zodiac snake"} alt={""} loading={"eager"} /></div>
                            <div className="zodiac-container" data-name="tiger"  ><img src={tiger}   data-name="tiger"   className={ (bigg === 12 ? "showBig" : "") + " zodiac tiger"} alt={""} loading={"eager"} /></div>
                        </div>
                    </div>
                </div>
                <div className="right-side">
                    <div className="video-box">
                        </div>
                    <div id="canvas1"></div>
                    <div className="redlantern">
                        <img src={redLantern} className="" alt={""} loading={"eager"} />
                    </div>
                    <div className="reel-word">
                        <span>SCRATCH & GET <br/> <i className="small-text">4 Lucky Numbers</i></span>
                        <div id="scratch-container">
                            <img src={scratch} className="" id="scratch-img" alt={""} loading={"eager"} />
                            <div className="" id="scratch-numbers">
                            </div>
                        </div>
                    </div>
                    <div className='backtobutton' onClick={()=>{ window.location.href="https://www.hiso33play.com"; }}></div>
                </div>
            </div>
        </div>
    );
}

export default Desktop;
